import React from 'react'
import { Field } from 'redux-form'
import {StyledInput} from '../../../../components/Form/StyledInput'
import getFormValidations from './formValidations'

// binding for redux-form
const Input = ({ input, meta:{touched, error}, id, tKey, path, placeholder, editable, disabled, translate, t, required, style, getPreview }) => {

    const translatedValue = translate ? t(input.value) : input.value
    const inputProps = Object.assign(input, {value: translatedValue})
    const translatedError = t(error)
    return <StyledInput {...inputProps} id={id} path={tKey || path} touched={touched} error={translatedError} required={required} disabled={disabled || !editable} style={style} placeholder={t(placeholder || 'typeSomething')} t={t} getPreview={getPreview}/>
}

// the binding function has to be outside to avoid re-rendering
// https://github.com/erikras/redux-form/issues/1094


class FormTextField extends React.Component {
    constructor(props) {
        super(props)
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return JSON.stringify(this.props) !== JSON.stringify(nextProps)
    }

    render() {
        const { field, t, objectMode, editObjectValues } = this.props
        const validations = getFormValidations(field, t, [], editObjectValues)

        return (
            <Field
                name={field.path}
                id={field.id}
                tKey={field.tKey}
                path={field.path}
                required={field.required}
                component={Input}
                placeholder={field.placeholder}
                validate={validations}
                normalize={(value, previousValue) => {
                    let normalizedValue = value
                    const maxLength = field.maxLength || field.exactLength
                    if(field.uppercase) normalizedValue = normalizedValue.toUpperCase()
                    if(field.lowercase) normalizedValue = normalizedValue.toLowerCase()
                    if(field.noSpaces) normalizedValue = _.replace(normalizedValue, /\s+/g, "");
                    if(field.numerical) normalizedValue = normalizedValue.replace(/[^\d]/g, '')
                    if(maxLength && normalizedValue.length > maxLength) normalizedValue = previousValue

                    return normalizedValue
                }}
                disabled={field.disabled || !field.writable}
                editable={!field.editable ? objectMode === 'newObject' : field.editable  }
                translate={field.translate}
                style={field.style}
                getPreview={field.getPreview}
                t={t}
            />
        )
    }
}
export default FormTextField
